import styled from 'styled-components';

const NoticeConfigurationStyled = styled.div`
  .basic-title {
    font-size: 19px;
    font-weight: 500;
    color: #000000;
    padding: ${(props) => props.theme.spacing(7)} 0
      ${(props) => props.theme.spacing(4)};
  }
  .notice-channel-title {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    margin-bottom: ${(props) => props.theme.spacing(28 / 8)};
  }
  .label-require {
    color: #ff0000;
    font-size: 14px;
  }
  .message-wrap {
    display: flex;
    flex-direction: row;
    gap: 57px;
    margin-bottom: ${(props) => props.theme.spacing(5)};
  }
  .notice-channel-box {
    width: 400px;
    .channel-box-title {
      height: 48px;
      background: #f6f6f6;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      line-height: 25px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      text-align: center;
      padding: 0 ${(props) => props.theme.spacing(67 / 8)} 0
        ${(props) => props.theme.spacing(43 / 8)};
      align-items: center;
    }
    .channel-box-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      text-align: center;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 25px;
      border-bottom: 1px solid #dddddd;
      span {
        width: 50%;
      }
    }
  }
  .member-rules {
    font-size: 14px;
    font-weight: 400;
    color: #c9c9c9;
    line-height: 50px;
    margin-left: ${(props) => props.theme.spacing(23 / 8)};
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .all-level-select {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 50px;
  }
  .MuiButtonBase-root-MuiRadio-root.Mui-disable {
    color: grey;
  }
  .cycle-select-wrap {
    display: inline-block;
  }
`;

export default NoticeConfigurationStyled;
